<template>
    <div class="home">
        <div class="home-banner">
            <!-- <Header></Header> -->
            <div class="intro-detail">
                <div class="home-title">
                    科技共建 生态家园
                </div>
                <p class="titlec-content">
                    地球是我们美丽可爱的家园。每个人都喜欢干净整洁的地球。现如今，世界气候异常、沙漠正在扩大、洪水正在泛滥、甚至动物也开始显得“疯狂”因此，保护环境迫在眉睫。
                </p>
                <div class="title-btn">
                    <span @click="knowMoreInfo">
                        了解详情 >
                    </span>
                </div>
            </div>
        </div>
        <!-- 主体区域 -->
        <div class="main-section">
            <div class="section-title">
                四大模块组成，满足全流程需求！
            </div>
            <div class="systom-list">
                <div
                    class="systom-item"
                    v-for="(item,index) in systomMenuList"
                    :key="index"
                >
                    <div
                        class="systom-info"
                        v-if="index % 2 == 0"
                    >
                        <img
                            :src="item.img"
                            alt=""
                        >
                        <div class="systom-detail">
                            <div class="detail-title">
                                {{ item.title }}
                            </div>
                            <p class="title-name">{{ item.nickName }}</p>
                            <p class="detail-content">{{ item.content }}</p>
                            <button
                                class="systom-btn"
                                @click="switchSubSystom(item.title)"
                            >立即体验 ></button>
                        </div>
                    </div>
                    <div
                        class="systom-info"
                        v-else-if="index % 2 == 1"
                    >
                        <div class="systom-detail">
                            <div class="detail-title">
                                {{ item.title }}
                            </div>
                            <p class="title-name">{{ item.nickName }}</p>
                            <p class="detail-content">{{ item.content }}</p>
                            <button
                                class="systom-btn"
                                @click="switchSubSystom(item.title)"
                            >立即体验 ></button>
                        </div>
                        <img
                            :src="item.img"
                            alt=""
                        >
                    </div>
                </div>
            </div>
        </div>
        <!-- 合作伙伴 -->
        <div class="company-list">
            <div class="comany-content">
                <div class="company-title">
                    携手共赢，品质铸就信赖
                </div>
                <ul class="company-img">
                    <li
                        v-for="(item,index) in companyLogoList"
                        :key="index"
                    >
                        <img
                            :src="item"
                            alt=""
                        >
                    </li>
                </ul>
            </div>
        </div>
        <!-- <Footer></Footer> -->
        <el-backtop></el-backtop>
    </div>
</template>

<script>
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { systomMenuList, companyLogoList } from "@/common/config";
export default {
    name: "Home",
    data() {
        return {
            systomMenuList,
            companyLogoList,
        };
    },
    components: {
        Header,
        Footer,
    },
    computed: {},
    methods: {
        knowMoreInfo() {
            window.location.href = "http://zimax.com.cn";
        },
        switchSubSystom(title) {
            switch (title) {
                case "开放遥感数据采集器":
                    window.open("http://cdata.zimax.com.cn");
                    break;
                case "遥感大数据智能管理平台":
                    window.open("http://mdata.zimax.com.cn");
                    break;
                case "遥感影像自动处理平台":
                    window.open("http://pdata.zimax.com.cn");
                    break;
                case "智能遥感专题数据包":
                    window.open("http://zplan.zimax.com.cn");
                    break;
            }
        },
    },
};
</script>
<style scoped>
p,
ul,
li {
    padding: 0;
    margin: 0;
}
li {
    list-style: none;
}
.home-banner {
    box-sizing: border-box;
    border: 1px solid transparent;
    width: 100%;
    height: 750px;
    background: url("../../assets/home/home_banner.png");
    position: relative;
}
.intro-detail {
    width: 645px;
    margin: auto;
    margin-top: 259px;
    text-align: center;
}
.home-title {
    height: 39px;
    font-size: 40px;
    font-family: "PingFangSC-Semibold, sans-serif";
    font-weight: bold;
    color: #ffffff;
    line-height: 40px;
}
.titlec-content {
    margin-top: 32px;
    font-size: 18px;
    font-family: "PingFangSC-Medium, sans-serif";
    color: #ececec;
    line-height: 32px;
}
.title-btn {
    margin: auto;
    margin-top: 80px;
    outline: none;
    width: 134px;
    height: 40px;
    border: 1px solid #f7f7f7;
    border-radius: 20px;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}
.title-btn span {
    display: inline-block;
    font-size: 14px;
    font-family: "PingFangSC-Medium, sans-serif";
    font-weight: 500;
    color: #ffffff;
    line-height: 36px;
}
.main-section {
    margin-top: 80px;
}
.section-title {
    height: 36px;
    font-size: 34px;
    font-family: "PingFangSC-Semibold, sans-serif";
    font-weight: bold;
    color: #333333;
    line-height: 22px;
    text-align: center;
    margin-bottom: 35px;
}
.systom-item:nth-of-type(2n + 1) {
    box-sizing: border-box;
    padding-top: 12px;
    padding-bottom: 60px;
}
.systom-item:nth-of-type(2n) {
    box-sizing: border-box;
    padding-top: 24px;
    padding-bottom: 36px;
    background: #f5f5f5;
}
.systom-item img {
    box-sizing: border-box;
    width: 569px;
    height: 440px;
    display: block;
    border: 1px dashed #888888;
}
.systom-item:nth-of-type(2n) img {
    margin-left: 125px;
}
.systom-info {
    width: 1200px;
    margin: auto;
    display: flex;
    justify-content: flex-start;
    align-items: center;
}
.systom-item:nth-of-type(2n + 1) .systom-detail {
    height: 440px;
    margin-left: 143px;
}
.systom-item:nth-of-type(2n) .systom-detail {
    height: 440px;
    margin-left: 79px;
    text-align: right;
}
.detail-title {
    font-size: 28px;
    font-family: "PingFangSC-Semibold, sans-serif";
    font-weight: bold;
    color: #333333;
    line-height: 36px;
    margin-top: 125px;
}
.title-name {
    font-size: 18px;
    font-family: "PingFangSC-Medium, sans-serif";
    font-weight: 500;
    color: #c5c5c5;
    line-height: 36px;
}
.systom-item .detail-content {
    width: 415px;
    height: 36px;
    margin-top: 35px;
    font-size: 14px;
    font-family: "PingFangSC-Regular,sans-serif";
    font-weight: 400;
    color: #454545;
    line-height: 22px;
}
.systom-btn {
    outline: none;
    box-sizing: border-box;
    width: 128px;
    height: 36px;
    margin-top: 85px;
    background: #27b3b1;
    border: 1px solid #27b3b1;
    border-radius: 17px;
    font-size: 14px;
    font-family: "PingFangSC-Regular,sans-serif";
    font-weight: 400;
    color: #ffffff;
    cursor: pointer;
}
.systom-item:nth-of-type(2n) .detail-content {
    text-align: right;
}
.company-list {
    margin-top: 99px;
    margin-bottom: 96px;
}
.comany-content {
    width: 1200px;
    margin: auto;
}
.company-title {
    font-size: 34px;
    font-family: "PingFangSC-Semibold, sans-serif";
    font-weight: bold;
    color: #333333;
    line-height: 22px;
    text-align: center;
    margin-bottom: 55px;
}
.company-img {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
}

.company-img li {
    width: 224px;
    height: 100px;
    margin-top: 15px;
    box-sizing: border-box;
    border: 1px dashed #888888;
}

.company-img li img {
    width: 100%;
    height: 100%;
    display: block;
}
.el-backtop,
.el-calendar-table td.is-today {
    color: #27b3b1;
}
@import url("../../assets/font/font.css");
</style>
